/**
 * ROROS actor label helpers — shared across UI pages.
 *
 * R-4 item 7 (J0-F Wave F.4): Extracted from ActorDetailPage.tsx and DomainDetailPage.tsx
 * where identical switch-case functions were duplicated. The version in ActorDetailPage
 * returned raw English strings (i18n gap); this version uses `t()` consistently.
 */

import { t } from '../i18n.js';
import { RorosActorType } from '@/types/roros/enums';

/**
 * Returns a translated display label for a ROROS actor type enum value.
 * Falls back to the raw type string for unknown values.
 */
export function actorTypeLabel(type: string): string {
  switch (type) {
    case RorosActorType.HUMAN:
      return t('Human');
    case RorosActorType.AI_OPERATOR:
      return t('AI Operator');
    case RorosActorType.KNOWLEDGE_PERSONA:
      return t('Knowledge Persona');
    default:
      return type;
  }
}
